// extracted by mini-css-extract-plugin
module.exports = {"vacancy-select-icon":"VacancySelect_vacancy-select-icon__3Ozfc","vacancy-select-icon--branded":"VacancySelect_vacancy-select-icon--branded__GC2LK"};